module.exports = __webpack_public_path__ + "static/media/project-07.efb76d20.png";